import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/index.vue";
import Home from "@/views/home.vue";
import About from "@/views/about.vue";
import Product from "@/views/product.vue";
import News from "@/views/news.vue";
import Service from "@/views/service.vue";
import Employ from "@/views/employ.vue";
import Contact from "@/views/contact.vue";
import Honor from "@/views/honor.vue";
import Sale from "@/views/sale.vue";
import Culture from "@/views/culture.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      redirect: 'home',
      component: Index,
      children:[
          {
              path: "/home",
              name: "home",
              component: Home
          },
          {
              path: "/about",
              name: "about",
              component: About
          },
          {
              path: "/product",
              name: "product",
              component: Product
          },
          {
              path: "/news",
              name: "news",
              component: News
          },
          {
              path: "/service",
              name: "service",
              component: Service
          },
          {
              path: "/employ",
              name: "employ",
              component: Employ
          },
          {
              path: "/contact",
              name: "contact",
              component: Contact
          },
          {
              path: "/honor",
              name: "honor",
              component: Honor
          },
          {
              path: "/sale",
              name: "sale",
              component: Sale
          },
          {
              path: "/culture",
              name: "culture",
              component: Culture
          },
          {
              path: "/newsDetail/:id",
              name: "newsDetail",
              component: (resolve) => {
    	        require(["@/views/newsDetail"], resolve);
    	      }
          },
          {
              path: "/productDetail/:id",
              name: "productDetail",
              component: (resolve) => {
    	        require(["@/views/productDetail"], resolve);
    	      }
          }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js